import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#060A14]" data-testid="portal-loading">
        <Loader2 className="animate-spin text-cyan" style={{ color: "#00F0FF" }} size={32} />
      </div>
    );
  }
  if (!user) return <Navigate to="/portal/login" replace />;
  return children;
}
